// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const updateUserAuthenticationType = async ({
    test,
}: {
    test: boolean,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleUpdateUserAuthenticationType = httpsCallable<
        Record<
            string,
            boolean
        >,
        boolean
    >(
        functions,
        'updateUserAuthenticationType',
    );
    return handleUpdateUserAuthenticationType({
        test,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default updateUserAuthenticationType;
